export const SHARED_DASHBOARD_QUERY = '-- Dashboard --';
export const DASHBOARD_DATASOURCE_PLUGIN_ID = 'dashboard';
